import React from 'react';

import { cx } from 'helpers/StylingHelpers';
import { useProductCardActions } from 'hooks/useProductCardActions';

import { ProductAddToCart } from '../../parts';

import type {
  IAnalyticsListProps, IOrder, IProduct, IProductVariant
} from 'types';

import styles from './ProductDefaultCardActions.module.scss';

interface Props {
  className?: string,
  //
  order?: IOrder,
  product: IProduct,
  variant: IProductVariant,
  listProps?: IAnalyticsListProps,
  //
  quantity: number,
  replaceProductVariantCode?: string,
  bypassAddressRequirement?: boolean,
  bypassQuantityVariants?: boolean,
  //
  isOrderLoading?: boolean,
  setLoading: (loading: boolean) => void,
  //
  onQuantityChange?: (data: IOrder) => void
}

const ProductDefaultCardActions = (props: Props) => {
  const {
    className,
    //
    order,
    product,
    variant,
    listProps = {},
    //
    quantity,
    replaceProductVariantCode,
    bypassAddressRequirement = false,
    bypassQuantityVariants = false,
    //
    isOrderLoading,
    setLoading,
    //
    onQuantityChange: onQuantityChangeSuccess
  } = props;

  // Hooks

  const {
    isOrderItemLoading,
    isProductActionLoading,
    isProductActionError,
    //
    handleAdd,
    handleBuyMore,
    handleQuantityChange,
  } = useProductCardActions({
    order,
    product,
    variant,
    listProps,
    //
    bypassAddressRequirement,
    bypassQuantityVariants,
    replaceProductVariantCode,
    //
    onQuantityChangeSuccess,
    //
    onAddStart: () => setLoading(true),
    onAddSettled: () => setLoading(false),
  });

  // --- Handlers

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // Render

  return (
    <div
      className={cx(styles.root, className)}
      onClick={onClick}
    >
      <ProductAddToCart
        //
        product={variant}
        quantity={quantity}
        //
        isReplace={!!replaceProductVariantCode}
        isAddToCartDisabled={isProductActionLoading || isOrderLoading}
        shouldReset={isProductActionError}
        shouldDisableQuantityHandler={isOrderItemLoading}
        bypassQuantityVariants={bypassQuantityVariants}
        canAddMultipleType={product?.canAddMultipleType}
        bmsmInfo={product?.bmsmInfo}
        //
        size="small"
        isInputRounded
        withAddToCartText
        withAddToCartIcon
        //
        onBuyMoreClick={handleBuyMore}
        onAddToCartClick={handleAdd}
        onQuantityChange={handleQuantityChange}
        //
      />
    </div>
  );
};

export default React.memo(ProductDefaultCardActions);
